import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../core/config/app.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { BrandingService } from '../core/services/branding.service';

@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.html',
    standalone: true,
    imports: [
        NgClass,
        RouterOutlet,
    ],
})
export class AuthLayout implements OnInit, OnDestroy {
    private readonly service = inject(AppService);
    readonly store = this.service.indexState;
    /** Resolve tenant logo by subdomain for unauthenticated pages. */
    protected readonly branding = inject(BrandingService);

    showTopButton = false;
    constructor(public storeData: Store<any>) {}
    headerClass = '';
    ngOnInit() {
        this.toggleLoader();
        // Resolve tenant branding from subdomain for login/register/lockscreen pages.
        this.branding.loadPublic();
        globalThis.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    ngOnDestroy() {
        globalThis.removeEventListener('scroll', () => {});
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
